import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOfferTypes = function () {
    return useApiCall(function (signal) { return api.configuration.apiConfigurationOfferTypeGet({ signal: signal }); }, null, true, []);
};
